import React from 'react';
import styles from './styles.scss';

export default ({ children, scrimClick, width }: Props) => {
  return (
    <div className={styles.modalWrapper}>
      <div className={styles.scrim} onClick={scrimClick} />
      <div className={styles.modal} style={{ width: width }}>
        {children}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/common/ModalLayout/index.js